var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoritesMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.009,
    height: 17.012,
    viewBox: "0 0 19.009 17.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7469",
    "data-name": "Path 7469",
    d: "M95.5,261.572,88,269l-7.5-7.428a5,5,0,1,1,7.5-6.566,5,5,0,1,1,7.5,6.572",
    transform: "translate(-78.487 -252.488)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesMenu);
export default __webpack_public_path__ + "static/media/favorites-menu.faabb6d667da6812f540877c82851b07.svg";
export { ForwardRef as ReactComponent };